<template>
  <div class="app">
    <div class="header-fixed">
      <AppHeader :simple="true" />
      <main class="main">
        <div class="app-body">
          <router-view/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader';

export default {
  name: 'simple',
  components: {
    AppHeader,
  },
  data() {
    return {};
  },
  computed: {

  },
  methods: {},
};
</script>
